import { memo } from "react";
import * as Styled from "./style";
import { WatchAccessControl } from "~/components/blocks/common/watch-access-control";

/**
 * 視聴制限がある場合に表示するヘッダー
 */
export const RestrictedHeader = memo(() => {
  return (
    <Styled.ArtRestrictedHeaderWrap>
      <WatchAccessControl isBlockDetailHeader={true} />
    </Styled.ArtRestrictedHeaderWrap>
  );
});

RestrictedHeader.displayName = "RestrictedHeader";
